import { gql } from "@apollo/client";

const CREATE_NOMINATIONS_PREFILLED = gql`
  mutation CreateNominationsPrefilled($data: [PrefilledNominationInput]) {
    createNominationsPrefilled(data: $data) 
  }
`;

export default CREATE_NOMINATIONS_PREFILLED;
